import { render, staticRenderFns } from "./ButtonGroupAction.vue?vue&type=template&id=2330a238&scoped=true"
import script from "./ButtonGroupAction.vue?vue&type=script&lang=js"
export * from "./ButtonGroupAction.vue?vue&type=script&lang=js"
import style0 from "./ButtonGroupAction.vue?vue&type=style&index=0&id=2330a238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2330a238",
  null
  
)

export default component.exports